/**
 * @generated SignedSource<<35a0cc648d3d4ee100a82e20814c29d4>>
 * @relayHash e1ed6aba8da97659395a220f6423a14c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5f5e36b4af1fa5ce40301d4c20435e04ebb8ca3ec6b43bd1ac7525444e822ddb

import type { ConcreteRequest } from 'relay-runtime';
export type DeleteDraftMutationForRevertDialogMutation$variables = {
  contentId: string;
};
export type DeleteDraftMutationForRevertDialogMutation$data = {
  readonly deleteContent: {
    readonly contentId: string;
  } | null;
};
export type DeleteDraftMutationForRevertDialogMutation = {
  response: DeleteDraftMutationForRevertDialogMutation$data;
  variables: DeleteDraftMutationForRevertDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Literal",
        "name": "action",
        "value": "DELETE_DRAFT"
      },
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      }
    ],
    "concreteType": "DeleteContentResponsePayload",
    "kind": "LinkedField",
    "name": "deleteContent",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "contentId"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "DeleteDraftMutationForRevertDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteDraftMutationForRevertDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e1ed6aba8da97659395a220f6423a14c",
    "id": "5f5e36b4af1fa5ce40301d4c20435e04ebb8ca3ec6b43bd1ac7525444e822ddb",
    "metadata": {},
    "name": "DeleteDraftMutationForRevertDialogMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteDraftMutationForRevertDialogMutation($contentId:ID!){deleteContent(contentId:$contentId,action:DELETE_DRAFT){contentId}}"
  }
};
})();

(node as any).hash = "dc1db2a944a11c9fd2ef0167c1bd4133";

export default node;
